import { useState, useEffect } from 'react'
import { Cookie, X } from 'lucide-react'

const STORAGE_KEY = 'clixyads_cookie_consent'

// Retorna true si el user ha consentido cookies analíticas/marketing.
// Usado por metaPixel + cualquier otro tracker para no disparar eventos sin consent.
export function hasMarketingConsent() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    const parsed = JSON.parse(v)
    return parsed?.marketing === true
  } catch { return false }
}

export function CookieBanner() {
  const [show, setShow] = useState(false)
  const [showDetails, setShowDetails] = useState(false)

  useEffect(() => {
    // Mostrar solo en landings públicas del SPA donde hay visitantes anónimos.
    // En el resto (login, dashboard, editor, legales, recursos) no aporta y molesta.
    const p = window.location.pathname
    const isPublicLanding = p.startsWith('/p/') || p.startsWith('/s/')
    if (!isPublicLanding) return
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) {
      const t = setTimeout(() => setShow(true), 800)
      return () => clearTimeout(t)
    }
  }, [])

  const save = (choice) => {
    const value = {
      essential: true, // no opcional
      analytics: choice === 'accept',
      marketing: choice === 'accept',
      timestamp: new Date().toISOString(),
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
    setShow(false)
    // Dispara evento para que otros módulos reaccionen
    window.dispatchEvent(new CustomEvent('clixyads:consent', { detail: value }))
  }

  if (!show) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 sm:bottom-6 z-50 sm:max-w-md">
      <div
        className="rounded-2xl p-5 relative shadow-2xl"
        style={{
          background: 'linear-gradient(135deg, rgba(34,211,238,0.06), rgba(139,92,246,0.06)), #12152B',
          border: '1px solid rgba(148,163,184,0.2)',
          backdropFilter: 'blur(18px)',
        }}
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-aurora-cyan/15 border border-aurora-cyan/30 flex items-center justify-center flex-shrink-0">
            <Cookie size={18} className="text-aurora-cyan" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-display text-sm text-white mb-1">Usamos cookies</h3>
            <p className="text-muted text-xs leading-relaxed mb-4">
              Las esenciales para que la app funcione + las de marketing (Meta Pixel) para entender qué anuncios traen clientes.
              Puedes rechazar las de marketing — la app funcionará igual.
            </p>
            {showDetails && (
              <div className="text-xs text-dim space-y-1.5 mb-4 pl-2 border-l-2 border-line">
                <p>✓ <strong className="text-muted">Esenciales:</strong> auth, preferencias (siempre)</p>
                <p>✓ <strong className="text-muted">Marketing:</strong> Meta Pixel, attribution</p>
                <p>✓ <strong className="text-muted">Analytics:</strong> Sentry (solo errores)</p>
                <p className="text-dim pt-1"><a href="/privacy-policy" className="underline">Política de privacidad</a></p>
              </div>
            )}
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => save('accept')}
                className="flex-1 min-w-[100px] px-4 py-2 text-xs font-medium bg-aurora-cyan text-ink rounded-lg hover:bg-aurora-cyan/90 transition-colors"
              >
                Aceptar todo
              </button>
              <button
                onClick={() => save('reject')}
                className="flex-1 min-w-[100px] px-4 py-2 text-xs font-medium bg-surface-2 border border-line text-muted rounded-lg hover:text-white transition-colors"
              >
                Solo esenciales
              </button>
              <button
                onClick={() => setShowDetails(d => !d)}
                className="text-xs text-dim hover:text-muted underline"
              >
                {showDetails ? 'Menos' : 'Detalles'}
              </button>
            </div>
          </div>
          <button
            onClick={() => save('reject')}
            className="text-dim hover:text-white transition-colors p-1 -m-1"
            aria-label="Cerrar (rechazar)"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  )
}
